'use client'

import { ReactNode } from 'react'
import { useEvent } from '@/app/_providers/EventProvider/EventProvider'
import styles from '@/app/_components/EventHeader/EventHeader.module.css'
import classNames from 'classnames'

const Banner = (): ReactNode => {
  const event = useEvent<Transformed.EventWithTimeslotsAndMeta>()
  const isAdminOnlyEvent = event.visibility === 'AdminOnly'

  if (!event.banner) {
    return null
  }

  return (
    <div
      className={classNames(
        styles.BannerText,
        { [styles.AdminBannerText]: isAdminOnlyEvent },
      )}
      data-testid="event-details-banner"
    >
      {event.banner}
    </div>
  )
}

export default Banner
